import { useSyncExternalStore } from 'react';
import { getActivitySnapshot, subscribeActivity } from './activityStore';
import { RecentPage } from './types';

export function useRecentPages(): RecentPage[] {
  return useSyncExternalStore(subscribeActivity, getActivitySnapshot, getActivitySnapshot);
}
